import React from "react";

function TextEditorButtons({ handleCancelar, handleSave, isSaving = false }) {
  return (
    <div className="relative bg-white pt-4 pb-2">
      <div className="flex justify-end">
        <button
          onClick={() => handleCancelar()}
          className={`w-auto btn-lightBlue font-bold mr-2 ${
            isSaving ? "cursor-not-allowed opacity-60" : ""
          }`}
          disabled={isSaving}
        >
          Cancelar
        </button>
        <button
          onClick={handleSave}
          className={`w-auto btn-nimbus font-bold ${
            isSaving ? "cursor-not-allowed opacity-60" : ""
          }`}
          disabled={isSaving}
          aria-busy={isSaving}
        >
          {isSaving ? "Guardando..." : "Guardar"}
        </button>
      </div>
    </div>
  );
}

export default TextEditorButtons;
